<div class="container-fluid no-gutters">
  <!-- init header content -->
  <div class="row my-3">
    <div class="col-md-12">
      <button *ngIf="ShowSaveButton" class="q-btn q-success" title="Enregistrer" (click)="SaveResa()">
        <i class="fas icon fa-save"></i>
      </button>
      <button *ngIf="ShowRemoveButton && param.model.IdDonneeFils !== '0'" class="q-btn q-danger" title="Supprimer" (click)="SetExtendedDeleteMessage()" data-toggle="modal" data-target="#ModalDelete" #modalDeleteBtn>
        <i class="fas fa-trash-alt"></i>
      </button>
      <button *ngIf="zoom && ShowSaveButton" class="q-btn q-primary ml-5" title="sauvegarder et ouvrir les options de vidéo-conférence" (click)="saveResaAndOpenZoom()">
        <i class="fas fa-video mr-2"></i>
        Salle Virtuelle
      </button>
    </div>
  </div>
  <!-- end  header content -->
  <!-- init body content -->
  <div class="row no-gutters">
    <!-- init left column -->
    <div class="col-lg-3">
      <div class="container-fluid no-gutters">
        <!-- title -->
        <div class="row">
          <div class="col-md-12">
            <h3 class="q-c-main">
              <i class="far fa-calendar-alt q-icon-title" aria-hidden="true"></i>&nbsp;
              <strong>Création réservation</strong>
            </h3>
          </div>
        </div>
        <!-- input text search stages -->
        <div class="row" *ngIf="selectedStageValue === ''">
          <div *ngIf="lstStagesByClient?.length > 0 ; then templateCustomerStagesList else qAutosearch" class="col-md-12"> </div>
          <ng-template #templateCustomerStagesList>
            <q-data-list class="w-100" [dataList]="lstStagesByClient" placeholder="association au stage" (qChange)="OnStageByClientChange($event)" (isValid)="ValidStageByClient($event)" deleteButton validDatas></q-data-list>
          </ng-template>
          <ng-template #qAutosearch>
            <q-autosearch [Mode]="'STAGE-RESERVATION'"
                          (SetInput)="getSelectedStage($event)"
                          class="w-100"
                          [CustomClass]="'q-light-main-focus-with-div-and-btn'"></q-autosearch>
          </ng-template>
        </div>
        <div class="row" *ngIf="selectedStageValue !== ''">
          <ng-container *ngFor="let SelectedStage of baseModel?.DataReservation.SelectedStages; let i = index">
            <div class="d-flex col-md-12">
              <strong class="selected-stage-text" [title]="SelectedStage.Text">{{SelectedStage.Text}}</strong>
              <a *ngIf="isQueovalContext" (click)="OpenStage(i)" class="ml-2">
                <i class="fas fa-search q-c-dark-primary q-pointer" title="Gestion {{baseModel?.DataReservation.SelectedStages.length > 1 ? 'des stages' : 'du stage'}}"></i>
              </a>
            </div>
          </ng-container>
        </div>
        <!--<div class="row" *ngIf="selectedStageValue !== ''">
          <div class="col-md-12">
            <div class="q-check">
              <input type="checkbox" id="2" [checked]="baseModel?.DataReservation.EditStageReservations" (change)="baseModel?.DataReservation.EditStageReservations = !baseModel?.DataReservation.EditStageReservations" />
              <label for="2" style="font-size:0.8rem;">
                <span></span>Modifier également les affectations des réservations associées
              </label>
            </div>
          </div>
        </div>-->
        <!-- select lieu -->
        <div class="row mt-2" *ngIf="baseModel && baseModel.DataReservation && baseModel.DataReservation.ListLieux && baseModel.DataReservation.ListLieux.length > 0">
          <div class="col-md-12">
            <label style="font-size: 0.8rem;">Choisir une adresse de convocation pour la réservation :</label>
            <select class="q-main-select form-control form-control-sm" [ngModel]="selectedLieuValue" (change)="selectLieu($event.target.value)">
              <option *ngFor="let b of baseModel?.DataReservation?.ListLieux" value="{{b.Value}}">{{b.Text}}</option>
            </select>
          </div>
        </div>
        <!-- select bureau -->
        <div class="row mt-2">
          <div class="col-md-12">
            <label style="font-size: 0.8rem;">Affectation pour gestion des réservations multi-stages :</label>
            <select class="q-main-select form-control form-control-sm" [ngModel]="selectedBureauValue" (change)="selectBureau($event.target.value)" [disabled]="!!strOfficeId">
              <option *ngFor="let b of baseModel?.DataReservation?.ListBureaux" value="{{b.Value}}">{{b.Text}}</option>
            </select>
          </div>
        </div>
        <!-- add participants -->
        <div class="col-12 mt-4 mb-2" *ngIf="baseModel && baseModel.DataReservation && baseModel.DataReservation.ListParticipants && baseModel.DataReservation.ListParticipants.Children.length > 0">
          <button type="button" class="q-btn q-secondary q-btn-add" title="Ajouter des participants" [ngbPopover]="popPrtpContent" [popoverTitle]="popPrtpTitle" placement="bottom" popoverClass="q-popover" [autoClose]="'outside'">
            <span class="ml-2">Collaborateur</span>
            <i class="fas fa-plus float-right mt-1 mr-1"></i>
          </button>
        </div>
        <!-- list participants -->
        <div class="col-12 p-3 q-zone-participant" *ngIf="baseModel && baseModel.DataReservation && baseModel.DataReservation.ListParticipants && afficheZoneParticipantBT(baseModel.DataReservation.ListParticipants.Children)">
          <ng-container *ngFor="let groupe of baseModel?.DataReservation?.ListParticipants?.Children">
            <ng-container *ngIf="oneUserCheckInGrp(groupe)">
              <!--<div class="w-100 q-c-main">
                <strong>{{groupe.Text}} :</strong>
              </div>-->
              <ng-container *ngFor="let user of groupe.Children">
                <ng-container *ngIf="user.IsChecked && user.IsVisible">
                  <div class="row q-line-user px-2">
                    <span>{{user.Text}}</span>
                    <span class="fa-stack fa-xs q-c-danger q-btn-partdelete float-right ml-auto" title="retirer le collaborateur" (click)="moveItem(groupe, user, 'C')">
                      <i class="fas fa-circle fa-stack-2x"></i>
                      <i class="fas fa-trash-alt fa-stack-1x fa-inverse" title="Retirer {{user.Text}}"></i>
                    </span>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
        <!-- add salles/materiel -->
        <div class="col-12 mt-4 mb-2" *ngIf="baseModel && baseModel.DataReservation && baseModel.DataReservation.ListObjects && baseModel.DataReservation.ListObjects.Children.length > 0">
          <button type="button" class="q-btn q-secondary q-btn-add" title="Ajouter des salles, matériels" [ngbPopover]="popSmContent" [popoverTitle]="popSmTitle" placement="bottom" popoverClass="q-popover" [autoClose]="'outside'">
            <span class="ml-2">Reservation salle, matériel</span>
            <i class="fas fa-plus float-right mt-1 mr-1"></i>
          </button>
        </div>
        <!-- list salles/materiel -->
        <div class="col-12 p-3 q-zone-participant" *ngIf="baseModel && baseModel.DataReservation && baseModel.DataReservation.ListObjects && afficheZoneParticipantBT(baseModel.DataReservation.ListObjects.Children)">
          <ng-container *ngFor="let groupe of baseModel?.DataReservation?.ListObjects?.Children">
            <ng-container *ngIf="oneUserCheckInGrp(groupe)">
              <div class="w-100 q-c-main">
                <strong>{{groupe.Text}} :</strong>
              </div>
              <ng-container *ngFor="let user of groupe.Children">
                <ng-container *ngIf="user.IsChecked">
                  <div class="row q-line-user px-2">
                    <span>{{user.Text}}</span>
                    <span class="fa-stack fa-xs q-c-danger q-btn-partdelete float-right ml-auto" title="retirer le collaborateur" (click)="moveItem(groupe, user, 'O')">
                      <i class="fas fa-circle fa-stack-2x"></i>
                      <i class="fas fa-trash-alt fa-stack-1x fa-inverse" title="Retirer {{user.Text}}"></i>
                    </span>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
    <!-- end  left column -->
    <!-- init middle column -->
    <div class="col">
      <q-bodisplay [param]="param" [globalsave]="globalSaveStage" (sendEvent)="getIdBoResa($event)" (boReady)="DisplayZoomButton()" (sendBoReady)="pageLoaded($event)"></q-bodisplay>
    </div>
    <!-- end  middle column -->
    <!-- init right column -->
    <div class="col-lg-4 col-xl-5" *ngIf="(baseModel && baseModel.DataReservation && baseModel.DataReservation.ListStagiaires && baseModel.DataReservation.ListStagiaires.length > 0) || (param.model.IdDonneeFils && param.model.IdDonneeFils !== '0')">

      <!--imite l'architecture du bo pour s'y aligner-->
      <div *ngIf="param?.model?.IdDonneeFils && param?.model?.IdDonneeFils != '0'" class="row">
        <div class="col-md-12">
          <h5 class="emargement-title">Emargement</h5>
        </div>

        <fieldset *ngIf="isApiSoWeSignExist" class="q-fieldset w-100 my-1">
          <legend>
            <a href="{{soWeSignURLportail.StrValue}}" target="_blank" style="color:white" title="Accéder au portail SoWeSign">
              <i class="fas fa-signature mr-2"></i>
              SOWESIGN
              <i class="fas fa-sign-in-alt ml-2"></i>
            </a>
          </legend>
          <div class="row">
            <div class="col-lg-10">
              <button class="q-btn q-main" (click)="SendSignatureSoWeSign();" [disabled]="isLoading" title="Créer une demande de signatures en envoyant un mail expirant au bout de 24 heures pendant la période de signature ou durant la séance par SoWeSign, sinon créer une demande de rattrapage en envoyant un mail avec une durée limite">Demander les signatures</button>
              <button class="q-btn q-main ml-1" (click)="GetSignatureSoWeSign();" [disabled]="isLoading" title="Récupérer les présences et les signatures de SoWeSign">Récupérer les signatures</button>
            </div>
          </div>
        </fieldset>


        <ng-container *ngFor="let groupe of baseModel?.DataReservation?.ListParticipants?.Children">
          <ng-container *ngIf="oneUserCheckInGrp(groupe)">
            <ng-container *ngFor="let user of groupe.Children">
              <div class="col-md-6" *ngIf="user.IsChecked && user.IsVisible">

                <div class="col-md-12">
                  <span>{{user.Text}}</span>
                  <ng-container *ngIf="!reloadEmargementFormateur">
                    <q-signature *ngIf="signatureAllowed"
                                 [signatureDisabled]="indParam.AppParams.LoggedUser.Ident != user.Value"
                                 [idPere]="user.Value"
                                 [idFils]="param.model.IdDonneeFils"
                                 width="300px"
                                 height="150px"
                                 nomRel="REL_BO_CNX_BO_RESERV"
                                 mode="FORMATEUR_RESERV"
                                 (fileExist)="user.IsAllowed = $event">
                    </q-signature>
                    <ng-container *ngIf="!signatureAllowed">
                      <div class="q-c-main detail">(Ce stage n'a pas encore eu lieu)</div>
                    </ng-container>
                  </ng-container>
                </div>
                <div *ngIf="user.IsAllowed" class="col-md-12 mt-2">
                  <button *ngIf="!deletingSignature && indParam.AppParams.LoggedUser.Ident == user.Value" class="q-btn q-danger" (click)="DeleteStgSignature(user.Value, param.model.IdDonneeFils, 'REL_BO_CNX_BO_RESERV')"><i class="fas fa-trash mr-2"></i>Supprimer la signature</button>
                  <button *ngIf="deletingSignature && indParam.AppParams.LoggedUser.Ident == user.Value" class="q-btn q-danger"><i class="fas fa-spin fa-pulse fa-spinner mr-2"></i>Supprimer la signature</button>
                </div>

              </div>
            </ng-container>
          </ng-container>
        </ng-container>

      </div>
      <div class="container-fluid">
        <div class="row">

          <div class="col-md-12">
            <strong class="text-muted">{{selectedStagesText}}</strong>
          </div>

        </div>
        <div class="row mt-2">
          <div class="col-md-12 mt-3">
            <table class="table table-striped table-condensed" style="font-size:0.8rem;" *ngIf="baseModel && baseModel.DataReservation && baseModel.DataReservation.ListStagiaires && baseModel.DataReservation.ListStagiaires.length > 0">
              <thead>
                <tr>
                  <th scope="col">{{ 'learner' | trad }}</th>

                  <th scope="col"></th>
                  <th scope="col" title="Inscrit"><input type="radio" value="PI" [ngModel]="globalPresence" name="headcoll" (click)="setRadio('PI');">&nbsp;Inscrit</th>
                  <th scope="col" title="{{ 'present' | trad}}"><input type="radio" value="P" [ngModel]="globalPresence" name="headcoll" (click)="setRadio('P');">&nbsp;Pres.</th>
                  <th scope="col" title="{{ 'absent' | trad }}"><input type="radio" value="A" [ngModel]="globalPresence" name="headcoll" (click)="setRadio('A');">&nbsp;Abs.</th>
                  <th scope="col" title="{{ 'unjustified' | trad }}"><input type="radio" value="AI" [ngModel]="globalPresence" name="headcoll" (click)="setRadio('AI');">&nbsp;Abs. Injust.</th>
                  <th scope="col"><input type="radio" value="" [ngModel]="globalPresence" name="headcoll" class="d-none"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let stg of baseModel?.DataReservation?.ListStagiaires; let i = index">
                  <th scope="row">
                    <p class="mb-0">
                      <span class="q-c-main">{{stg.strNom}} {{stg.strPrenom}}</span>
                      <span class="q-email-apprenant">{{stg.strNumeroTelFixe ? " - " + stg.strNumeroTelFixe : ''}}{{stg.strNumeroTelPortable ? " - " + stg.strNumeroTelPortable : ''}}</span>
                    </p>
                    <p class="q-email-apprenant">{{stg.strEmail ? stg.strEmail : ''}}</p>
                  </th>
                  <td>
                    <div *ngIf="stg.pathEmargement"
                         [ngbPopover]="f1"
                         [placement]="['auto', 'auto']"
                         autoClose="outside"
                         container="body"
                         #p1="ngbPopover"
                         class="q-pointer"
                         style="border: 2px solid var(--c-main);">
                      <div class="w-100 h-100" ngbPopover="{{ stg.infoEmargement}}" [disablePopover]="p1.isOpen()" triggers="mouseenter:mouseleave">
                        <!--<i class="fas fa-signature fa-2x q-c-main"></i>-->
                        <img *ngIf="!stg.pathExistButUnfounded" style="max-width: 48px;max-height: 48px" [src]="sanitize.bypassSecurityTrustResourceUrl(stg.pathEmargement)" />
                        <i *ngIf="stg.pathExistButUnfounded" class="fas fa-signature fa-2x q-c-main"></i>
                      </div>
                      <ng-template #f1>
                        <img *ngIf="!stg.pathExistButUnfounded" [src]="sanitize.bypassSecurityTrustResourceUrl(stg.pathEmargement)" />
                        <i *ngIf="stg.pathExistButUnfounded" class="fas fa-signature fa-2x q-c-main"></i>
                        <button *ngIf="!deletingSignature" class="q-btn q-danger" (click)="DeleteStgSignature(stg.strIdent, baseModel.EventId, 'REL_BO_CONTACT_BO_RESERV_P', stg)"><i class="fas fa-trash mr-2"></i>Supprimer la signature</button>
                        <button *ngIf="deletingSignature" class="q-btn q-danger"><i class="fas fa-spin fa-pulse fa-spinner mr-2"></i>Supprimer la signature</button>
                      </ng-template>
                    </div>
                  </td>
                  <td><input type="radio" value="PI" [ngModel]="stg.presence" (click)="UpdatePresence('PI', stg)" name="{{i}}" /></td>
                  <td><input type="radio" value="P" [ngModel]="stg.presence" (click)="UpdatePresence('P', stg)" name="{{i}}" /></td>
                  <td><input type="radio" value="A" [ngModel]="stg.presence" (click)="UpdatePresence('A', stg)" name="{{i}}" /></td>
                  <td><input type="radio" value="AI" [ngModel]="stg.presence" (click)="UpdatePresence('AI', stg)" name="{{i}}" /></td>
                  <td><input class="d-none" type="radio" value="" [ngModel]="stg.presence" name="{{i}}" /></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- end right column -->
  </div>
  <!-- end  body content -->
</div>



<ng-template #popPrtpTitle>Choisir les participants</ng-template>
<ng-template #popPrtpContent>
  <ng-container *ngIf="baseModel && baseModel.DataReservation && baseModel.DataReservation.ListParticipants && baseModel.DataReservation.ListParticipants.Children && baseModel.DataReservation.ListParticipants.Children.length > 0">
    <div class="p-2">
      <ng-container *ngFor="let groupe of baseModel?.DataReservation?.ListParticipants?.Children">
        <ng-container *ngIf="groupe.Children && groupe.Children.length > 0 && !allUserCheckInGrp(groupe)">
          <div class="my-3">
            <strong>{{groupe.Text}} :</strong>
            <span class="fa-stack fa-xs float-right mr-2 q-c-main" (click)="moveItemGroup(groupe, 'C')" *ngIf="groupe.Children && groupe.Children.length > 0">
              <i class="fas fa-circle fa-stack-2x"></i>
              <i class="fas fa-plus fa-stack-1x fa-inverse" title="Ajouter tous les {{groupe.Text}}"></i>
            </span>
          </div>
          <hr class="m-0" />
        </ng-container>

        <ng-container *ngIf="groupe.Children.length > 0">
          <ng-container *ngFor="let user of groupe.Children">
            <ng-container *ngIf="!user.IsChecked">
              <div class="q-line-adduser" (click)="moveItem(groupe, user, 'C')">
                <span class="ml-2">{{user.Text}}</span>
                <span class="fa-stack fa-xs float-right mr-2 q-c-main q-btn-addpart">
                  <i class="fas fa-circle fa-stack-2x"></i>
                  <i class="fas fa-plus fa-stack-1x fa-inverse" title="Ajouter {{user.Text}}"></i>
                </span>
              </div>
              <hr class="m-0" />
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
  <ng-container *ngIf="!baseModel || !baseModel.DataReservation || !baseModel.DataReservation.ListParticipants || !baseModel.DataReservation.ListParticipants.Children || baseModel.DataReservation.ListParticipants.Children.length === 0">
    Aucun collaborateur à ajouter
  </ng-container>
</ng-template>

<ng-template #popSmTitle>Choisir les salles et le matériel</ng-template>
<ng-template #popSmContent>
  <ng-container *ngIf="baseModel && baseModel.DataReservation && baseModel.DataReservation.ListObjects && baseModel.DataReservation.ListObjects.Children && baseModel.DataReservation.ListObjects.Children.length > 0">
    <div class="p-2 popover-smContent">
      <ng-container *ngFor="let groupe of baseModel?.DataReservation?.ListObjects?.Children">
        <ng-container *ngIf="groupe.Children && groupe.Children.length > 0 && !allUserCheckInGrp(groupe)">
          <div class="my-3">
            <strong>{{groupe.Text}} :</strong>
            <span class="fa-stack fa-xs float-right mr-2 q-c-main" (click)="moveItemGroup(groupe, 'O')" *ngIf="groupe.Children && groupe.Children.length > 0">
              <i class="fas fa-circle fa-stack-2x"></i>
              <i class="fas fa-plus fa-stack-1x fa-inverse" title="Ajouter tous les {{groupe.Text}}"></i>
            </span>
          </div>
          <hr class="m-0" />
        </ng-container>
        <ng-container *ngIf="groupe.Children.length > 0">
          <ng-container *ngFor="let user of groupe.Children">
            <ng-container *ngIf="!user.IsChecked">
              <div class="q-line-adduser" (click)="moveItem(groupe, user, 'O')">
                <span class="ml-2">{{user.Text}}</span>
                <span class="fa-stack fa-xs float-right mr-2 q-c-main q-btn-addpart">
                  <i class="fas fa-circle fa-stack-2x"></i>
                  <i class="fas fa-plus fa-stack-1x fa-inverse" title="Ajouter {{user.Text}}"></i>
                </span>
              </div>
              <hr class="m-0" />
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
  <ng-container *ngIf="!baseModel || !baseModel.DataReservation || !baseModel.DataReservation.ListObjects || !baseModel.DataReservation.ListObjects.Children || baseModel.DataReservation.ListObjects.Children.length === 0">
    Aucun salle au matériel à ajouter
  </ng-container>
</ng-template>

<!-- Modal suppression fichier -->
<div class="modal fade" id="ModalDelete" tabindex="-1" role="dialog" aria-labelledby="ModalDelete" aria-hidden="true" #deleteModal>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title ml-3"> Suppression d'une Réservation</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModalDelete()" #closeDelete>
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="container">
          <br />
          <div class="row justify-content-center">
            {{extendedDeleteMessage}}
            Voulez-vous vraiment supprimer cette réservation ?
          </div>
          <br />
          <div class="row">
            <div class="col-md-12 text-center">
              <div class="row">
                <div class="col-md-6 text-center">
                  <button type="button" class="btn btn-success" (click)="confirmDelete()">Oui <i class="fas fa-check ml-2"></i></button>
                </div>
                <br />
                <div class="col-md-6 text-center">
                  <button type="button" class="btn btn-danger" (click)="closeModalDelete()">Non <i class="fas fa-times ml-2"></i></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

